// utils/formatters.js
export const formatImporte = (importe) => {
  if (importe === undefined || importe === null) return '0,00';
  const partes = Number(importe).toFixed(2).split('.');
  const parteEntera = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${parteEntera},${partes[1]}`;
};

export const getMedioPagoName = (medio_pago) => {
  switch(medio_pago) {
    case 6: return "QR";
    case 10: return "Efectivo";
    default: return "Otro";
  }
};

export const parseImporte = (value) => {
  return parseFloat(value.replace(',', '.'));
};